app.controller('BrowseFilterDoorController', ['$rootScope', '$scope', function ($rootScope, $scope) {

    const siteHelper = $rootScope.site_helper;

    $scope.doesModelRequireStep = function (conditionModel) {
        if (conditionModel.id === "m2m") {
            return false;
        }
        return true;
    }

    $scope.onStepsCreated = function () {
        const steps = $scope.view_model.steps;
        for (let stepID in steps) {
            const step = steps[stepID];
            switch (stepID) {
                case "express_24":
                    step.list_name = "Stocked or Made to Measure";
                    break;
                case "manufacturing_process":
                    step.list_name = "Door Specification";
                    break;
                case "base_style":
                    step.list_name = "Door Style";
                    break;
                case "base_colour":
                    step.list_name = "Door Colour";
                    break;
                case "finish":
                    step.list_name = "Door Finish";
                    break;
                default:
                    break;
            }
        }
    }
    $scope.filter_functions.doesModelRequireStep = $scope.doesModelRequireStep;
    $scope.filter_functions.onStepsCreated = $scope.onStepsCreated;

    $scope.stepCurrentChoiceName = function (stepID) {
        if (stepID === "express_24") {
            return null;
        }
        return $scope.$parent.stepCurrentChoiceName(stepID);
    }

    $scope.handleExpress24Radio = function () {
        $scope.handleStepRadio(null, "express_24");
        if ($scope.condition_models.express_24.current_value === "express_24_if_yes") {
            $scope.showNextStep("express_24");
        }

    }

    $scope.populateFilter();


}]);